export default __webpack_public_path__ + "static/media/deal.7f40b8cc.jpeg";